var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7266 31.6139C13.0809 19.2836 30.75 8.88475 43.2744 12.9069C30.0994 12.883 17.2757 21.5355 10.7266 31.6139Z",
    fill: "#11D16A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4034 51.336C59.2261 44.8904 67.1691 32.6686 63.1445 24.0379C59.12 15.4073 44.652 13.636 30.8293 20.0816C17.0066 26.5272 9.06363 38.749 13.0882 47.3796C17.1127 56.0103 31.5808 57.7816 45.4034 51.336ZM27.9991 45.3758L31.9066 29.0225C32.4246 26.8549 34.2611 25.2549 36.4792 25.0388L46.9786 24.0159C49.0069 23.8183 50.6229 25.6825 50.1396 27.6622C49.8429 28.8776 48.8137 29.775 47.5692 29.9034L39.5553 30.7304C38.6817 30.8206 37.964 31.4601 37.774 32.3176C37.4779 33.654 38.5567 34.8967 39.9214 34.7914L41.6095 34.6613C43.2278 34.5364 44.4893 36.0394 44.0858 37.6115C43.8421 38.5611 43.0386 39.2624 42.0648 39.3754L37.0599 39.9566C36.4084 40.0322 35.8692 40.4978 35.6994 41.1312L34.1439 46.9333C33.7724 48.3189 32.5167 49.2823 31.0821 49.2823C29.0335 49.2823 27.523 47.3683 27.9991 45.3758Z",
    fill: "#11D16A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7307 23.4093C71.4642 33.5603 62.6618 47.6833 47.07 54.9539C31.4782 62.2244 15.0013 59.8894 10.2678 49.7384C9.04893 47.1244 8.72759 44.2471 9.18862 41.2912C7.68154 45.7264 7.6742 50.143 9.48542 54.0272C14.6237 65.0464 32.4524 67.6079 49.3068 59.7486C66.1611 51.8892 75.6589 36.5852 70.5206 25.566C68.7083 21.6796 65.3175 18.8453 60.9476 17.1492C63.5111 18.6964 65.5109 20.7933 66.7307 23.4093Z",
    fill: "#11D16A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0026 50.3766C66.0931 61.224 49.7007 70.0164 39.138 67.0654C51.6693 66.005 62.4159 57.4725 68.0026 50.3766Z",
    fill: "#11D16A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-dark.c6fb9c1be6dbca861f7f30bca06e151e.svg";